import api from "@/api/v1-jwt/config/api";

export const fetchContacts = async (userId) => {
  if (!userId) {
    throw new Error("[FETCH_CONTACTS] User ID missing.");
  }

  const { data } = await api.get(`/platform/contacts/${userId}`);
  return data?.data;
};

export const fetchContactById = async ({ userId, contactId }) => {
  if (!userId) {
    throw new Error("[FETCH_CONTACT_BY_ID] User ID missing.");
  }

  if (!contactId) {
    throw new Error("[FETCH_CONTACT_BY_ID] Contact ID missing.");
  }

  try {
    const { data } = await api.get(
      `/platform/contacts/${userId}?contact_id=${contactId}`
    );

    return data?.data;
  } catch (error) {
    console.log(error);
  }
};

export const createContact = async ({ userId, payload }) => {
  if (!userId) {
    throw new Error("[CREATE_CONTACT] User ID missing.");
  }

  if (payload === undefined || payload === null) {
    throw new Error("[CREATE_CONTACT] Payload missing.");
  }

  const { data } = await api.post(`/platform/contacts/${userId}`, {
    ...payload,
    cognito_id: userId,
  });

  return data;
};

export const updateContact = async ({ userId, contactId, payload }) => {
  if (!userId) {
    throw new Error("[UPDATE_CONTACT] User ID missing.");
  }

  if (!contactId) {
    throw new Error("[UPDATE_CONTACT] Contact ID missing.");
  }

  if (payload === undefined || payload === null) {
    throw new Error("[UPDATE_CONTACT] Payload missing.");
  }

  const { data } = await api.patch(
    `/platform/contacts/${userId}/${contactId}`,
    payload
  );

  return data;
};

export const deleteContact = async ({ userId, contactId }) => {
  if (!userId) {
    throw new Error("[DELETE_CONTACT] User ID missing.");
  }

  if (!contactId) {
    throw new Error("[DELETE_CONTACT] Contact ID missing.");
  }

  const { data } = await api.delete(
    `/platform/contacts/${userId}/${contactId}`
  );
  return data;
};
